import ErrorSubclass from 'util/ErrorSubclass';

export default class ConvertToChartPropsException extends ErrorSubclass {}
